import styled from 'styled-components';

import { style } from '@genially/design-system';

interface WrapperProps {
  $columns: number;
}

export const Wrapper = styled.div<WrapperProps>(({ theme: { size }, $columns }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${$columns}, 1fr)`,
  gap: size.units(2),

  // No width left to split below sm: one card per row.
  ...style.mixins.responsive.sm.downward({
    gridTemplateColumns: '1fr',
  }),
}));
